import { render, staticRenderFns } from "./StudyRequestStatusRenderer.vue?vue&type=template&id=fa32e17a&"
import script from "./StudyRequestStatusRenderer.vue?vue&type=script&lang=js&"
export * from "./StudyRequestStatusRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports